export default __webpack_public_path__ + "static/media/Substrates-Section-Connect.9ebcd15d.jpg";